import TooltipIcon from 'ext-ui/components/TooltipIcon/TooltipIcon'
import React from 'react'
import AttachmentVerificationTooltip from 'src/components/AttachmentVerificationTooltip/AttachmentVerificationTooltip'
import { useTranslate } from 'src/localization/Trns'
import {
  ReceiptVerificationStatus,
  receiptVerificationStatusToIcon,
  receiptVerificationStatusToTooltip,
} from 'src/models/receiptVerification.models'
import { css } from 'styled-components'

interface ReceiptVerificationCellProps {
  status?: ReceiptVerificationStatus
  reasons?: string[]
}

export default function ReceiptVerificationCell({
  status,
  reasons,
}: ReceiptVerificationCellProps): React.ReactElement | null {
  const translate = useTranslate()
  if (!status) return null

  const label = translate(receiptVerificationStatusToTooltip(status))

  // Match ReceiptsTooltip's layout box so both icons share the same X/Y offset
  // in the Receipts column: render SVG at native 24×24 and shrink visually via
  // CSS transform. Visual size stays 20px; layout box becomes 24×24 so rows
  // rendering ReceiptsTooltip (verified) and this cell (not-verified) land on
  // the same baseline.
  const icon = (
    <span
      css={css`
        display: flex;
        align-items: center;
        transform: scale(calc(20 / 24));
      `}
      aria-label={label}
    >
      {receiptVerificationStatusToIcon(status, 24)}
    </span>
  )

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
      `}
    >
      <TooltipIcon
        placement="top"
        icon={icon}
        iconTestId={`receipt-verification-${status.toLowerCase()}`}
      >
        <AttachmentVerificationTooltip status={status} reasons={reasons} />
      </TooltipIcon>
    </div>
  )
}
